import React from 'react';

import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import LockIcon from '~/assets/icons/LockIcon';
import CustomButton from '~/components/UI/CustomButton/CustomButton';
import { H3 } from '~/components/UI/Texts';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { PRICING_ROUTE } from '~/routes';
import { MIDDLE_RADIUS_PX, SMALL_MARGIN_PX, SUBMIDDLE_MARGIN_PX } from '~/theme';

const StartFreeTrial = () => {
  const { t } = useTenantTranslation();
  const theme = useTheme();

  return (
    <Wrapper>
      <Section>
        <StyledBlockLockIcon color={theme.palette.common.violetSecondary} />
        <StyledTitle>{t('button.startFreeTrial')}</StyledTitle>
      </Section>
      <Text>{t('page.news.unlockAccess')}</Text>
      <StyledLink to={PRICING_ROUTE}>
        <CustomButton>{t('button.startFreeTrial')}</CustomButton>
      </StyledLink>
    </Wrapper>
  );
};

export default StartFreeTrial;

const Wrapper = styled('div')`
  padding: 36px 36px 36px 24px;
  background: ${({ theme }) => theme.palette.common.blackSecondary};
  border-radius: ${MIDDLE_RADIUS_PX};
  display: flex;
  gap: ${SUBMIDDLE_MARGIN_PX};
  flex-direction: column;
  margin-bottom: 36px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 48px 36px;
    flex-direction: row;
  }
`;
const StyledLink = styled(Link)`
  min-width: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
  &&:hover {
    text-decoration: none;
  }
`;
const Section = styled('div')`
  display: flex;
  align-items: center;
`;
const StyledBlockLockIcon = styled(LockIcon)`
  width: 24px;
  height: 24px;
  margin-right: ${SMALL_MARGIN_PX};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-right: ${SUBMIDDLE_MARGIN_PX};
    min-width: 54px;
    height: 54px;
  }
`;
const Text = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray};
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: left;
  margin-left: 40px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-left: 0;
  }
`;
const StyledTitle = styled(H3)`
  min-width: 85px;
`;
